export class Availability {
  constructor() {
    this.availability = false;
  }
  public availability: boolean;
}
